import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import ProgressDate from './ProrgressDate';
import useTimeline from '../../hooks/useTimeline';
const StyledItems = styled.div `
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    z-index: 2;
    position: relative;
`;
const ProgressItems = ({ startDate, latestDate, current, }) => {
    const { getTotalMonths, getLatestDate, getStartDate, getCurrentDate, } = useTimeline(startDate, latestDate, current);
    const INTERVAL_MONTH = 1;
    const INTERVAL_QUARTER = 3;
    const INTERVAL_YEAR = 12;
    const MONTH_NAMES = [
        'jan',
        'feb',
        'mrt',
        'apr',
        'mei',
        'jun',
        'jul',
        'aug',
        'sep',
        'okt',
        'nov',
        'dec',
    ];
    const [items, setItems] = useState([]);
    const progressWrapperRef = useRef(null);
    const getMaxShownItems = () => {
        return Math.floor(getAvailableHeight() / getItemHeight());
    };
    const getItemHeight = () => {
        // Static height.
        // Could calculate the height of a single item but it would still require a static margin
        return 80;
    };
    const getAvailableHeight = () => {
        return progressWrapperRef.current?.offsetHeight ?? 0;
    };
    const getDrawInterval = () => {
        const duration = getTotalMonths();
        const maxShown = getMaxShownItems();
        let interval = duration / maxShown;
        if (interval <= INTERVAL_MONTH) {
            return INTERVAL_MONTH;
        }
        if (interval <= INTERVAL_QUARTER) {
            return INTERVAL_QUARTER;
        }
        return INTERVAL_YEAR;
    };
    const getMonthsToDraw = () => {
        {
            const lastDate = getLatestDate();
            const firstDate = getStartDate();
            const interval = getDrawInterval();
            const toDraw = [lastDate];
            let currentPosition = lastDate;
            const drawnAll = () => {
                if (currentPosition.getFullYear() < firstDate.getFullYear()) {
                    return true;
                }
                if (currentPosition.getFullYear() === firstDate.getFullYear() &&
                    currentPosition.getMonth() <= firstDate.getMonth()) {
                    return true;
                }
                return false;
            };
            while (!drawnAll()) {
                currentPosition = new Date(currentPosition.getFullYear(), currentPosition.getMonth() - interval, 1);
                toDraw.push(currentPosition);
            }
            return toDraw;
        }
    };
    const formatToDrawItems = (persist) => {
        const interval = getDrawInterval();
        const toDraw = getMonthsToDraw();
        const items = [];
        toDraw.forEach((item, index) => {
            if (interval === INTERVAL_MONTH) {
                items.push({
                    date: toDraw[index],
                    primary: MONTH_NAMES[toDraw[index].getMonth()],
                    secondary: String(toDraw[index].getFullYear()),
                });
            }
            if (interval === INTERVAL_QUARTER) {
                items.push({
                    date: toDraw[index],
                    primary: 'Q' +
                        String(Math.floor(toDraw[index].getMonth() / 3) + 1),
                    secondary: String(toDraw[index].getFullYear()),
                });
            }
            if (interval === INTERVAL_YEAR) {
                items.push({
                    date: toDraw[index],
                    primary: String(toDraw[index].getFullYear()),
                    secondary: undefined,
                });
            }
        });
        if (persist) {
            setItems(items);
        }
        return items;
    };
    useEffect(() => {
        window.addEventListener('resize', () => formatToDrawItems(true));
        return () => {
            window.removeEventListener('resize', () => formatToDrawItems(true));
        };
    }, []);
    useEffect(() => {
        const items = formatToDrawItems(false);
        const news = items.map(item => {
            const active = item.date >= getCurrentDate();
            return { ...item, active };
        });
        setItems(news);
    }, [current]);
    return (_jsx(StyledItems, { ref: progressWrapperRef, children: items.map(({ primary, secondary, active }, index) => {
            return (_jsx(ProgressDate, { date: primary, secondary: secondary, active: active }, primary + index));
        }) }));
};
export default ProgressItems;
